export default __webpack_public_path__ + "static/avatar-05-dcece314d94aafdaf14856c7cdaecad4.svg";